export const QUICK_INPUT_LIMIT = 500;

const RANGE_SHAPE = /^[^-]+-[^-]+$/;
const DIGIT_RANGE = /^(\d+)-(\d+)$/;

const tokensOf = (text) => String(text == null ? '' : text).split(/[\s,]+/).filter((token) => token !== '');

const rangeSize = (start, end) => end - start + 1;

const expandRange = (startText, endText) => {
  const start = Number(startText);
  const end = Number(endText);
  const width = startText.length === endText.length ? startText.length : 0;
  const exts = [];
  for (let value = start; value <= end; value += 1) {
    exts.push(width ? String(value).padStart(width, '0') : String(value));
  }
  return exts;
};

export const parseExtensionInput = (text, { limit = QUICK_INPUT_LIMIT } = {}) => {
  const exts = [];
  const seen = new Set();
  const invalidTokens = [];
  let total = 0;

  const push = (ext) => {
    if (seen.has(ext)) return;
    seen.add(ext);
    exts.push(ext);
  };

  for (const token of tokensOf(text)) {
    if (!token.includes('-')) {
      total += 1;
      if (total > limit) return { exts: [], invalidTokens, limitExceeded: true };
      push(token);
      continue;
    }
    const match = token.match(DIGIT_RANGE);
    if (!RANGE_SHAPE.test(token) || !match || Number(match[1]) > Number(match[2])) {
      invalidTokens.push(token);
      continue;
    }
    total += rangeSize(Number(match[1]), Number(match[2]));
    if (total > limit) return { exts: [], invalidTokens, limitExceeded: true };
    expandRange(match[1], match[2]).forEach(push);
  }

  return { exts, invalidTokens, limitExceeded: false };
};
